import React, { useEffect } from 'react';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import { Pie } from 'react-chartjs-2';

import api from './../../../services/axios'
import Loading from './../../../compoments/Loading';
import NavBack from './../../NavBack';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
}));

const dateToString = (date, time, format = false) => {
  let theme = createMuiTheme();
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  const yyyy = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  let timeString = '';
  if (time) {
    timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
  }
  if (!format) {
    return yyyy + '-' + mm + '-' + dd + '' + timeString;
  }
  return dd + '/' + mm + '/' + yyyy + ' ' + timeString;
}

const addDays = function (date, daysToAdd) {
  var _24HoursInMilliseconds = 86400000;
  return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
}

export default function Pausas({ theme }) {

  const classes = useStyles();
  const [da, setDa] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [heightG, setHeightG] = React.useState(true);

  const [start, setStart] = React.useState(() => {
    const dt = new Date();
    return addDays(dt, -30); // padrão de dias atrás
  });
  const [end, setEnd] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(23)
    dt.setMinutes(59);
    return dt;
  });

  const loadData = async (start, end) => {
    setLoading(true)
    const uri = 'v1/graficos/pausas?start=' + dateToString(start, true) + '&end=' + dateToString(end, true);
    console.log('uri', uri)
    const { data } = await api.get(uri)
    setLoading(false)
    setDa(data)
  }

  useEffect(() => {

    let h = (window.innerHeight
      || document.documentElement.clientHeight) - 100;
    setHeightG(h)

    loadData(start, end)
    setInterval(() => {
      loadData(start, end)
    }, 30000)
  }, [])

  const tooltips = {
    enabled: true,
    callbacks: {
      label: function (tooltipItem, data) {
        let title = tooltipItem && ' ' + tooltipItem.label;
        return title;
      },
    },
  }
  const options = {
    plugins: {
      legend: {
        display: true,
      },
      tooltip: tooltips,
    },
    maintainAspectRatio: false,
  };

  return (
    <>
      <AppBar position="absolute"
      >
        <NavBack
          titleHeader={'voltar'}
        />
      </AppBar>
      <div className={classes.appBarSpacer} />
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {loading ? <Loading /> :
              <div style={{ padding: '20px 40px' }}>
                <div className='header' style={{ paddingTop: 20 }}>
                  <h1 className='title'>Gráfico de Pausas</h1>
                  <h4>De {dateToString(start, true, true)} até {dateToString(end, true, true)}</h4>
                </div>
                <Paper className={classes.paper}>
                  <Pie
                    data={da}
                    height={heightG}
                    options={options}
                  />
                </Paper>
              </div>
            }
          </Grid>
        </Grid>
      </div>
    </>
  );
}
